define(['jquery'], function ($) {

    function LanguageSelector() {
    }

    LanguageSelector.prototype.init = function () {
        $('#footerLanguageSelector').replaceWith($('#languageHint div.language__selector').clone());

        $('.footer .language__selector').on('click', function (e) {
            e.stopPropagation();
            let $el = $(e.target).closest('.language__selector');
            if ($el.hasClass('language__selector__active') === false) {
                e.preventDefault();
                // not using jQuery here to avoid magic blocking event propagation
                document.getElementsByTagName('body')[0].onclick = function () {
                    $('.language__selector__active').removeClass('language__selector__active');
                }
                $el.addClass('language__selector__active');
            }
        });

        $('.footer .language__selector .language__menu__selector li > a').on('click', function (e) {
            localStorage.setItem('hb180-bauwerk-language-choosen', $(this).parent().data('locale'));
        });

    };

    return LanguageSelector;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/languageSelector.js